import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useAuthStore } from '@/stores/auth.store';
import { logout as apiLogout } from '@/services/rbac-auth.service';
import { ROUTES, UNE_PERM } from '@/constants';

const APP_ACCESS_PERMISSION = UNE_PERM.APP_ACCESS;

export function AppAccessGate({ children }: { children: ReactNode }): ReactNode {
  const { status, hasPermission } = useAuth();

  const onLogout = async () => {
    try { await apiLogout(); } catch { /* limpiamos igual */ }
    useAuthStore.getState().clearAuth();
    window.location.href = ROUTES.LOGIN;
  };

  // No decidir mientras la sesión no resolvió (evita parpadeo de "sin acceso").
  if (status === 'idle' || status === 'loading') {
    return <div className="fixed inset-0 flex items-center justify-center">Cargando…</div>;
  }

  if (!hasPermission(APP_ACCESS_PERMISSION)) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-2xl font-semibold">No tenés acceso a esta aplicación</h1>
        <p className="max-w-md text-muted-foreground">
          Tu cuenta no tiene permisos para usar esta aplicación. Si creés que es un error, contactá al administrador.
        </p>
        <button className="underline" onClick={onLogout}>Cerrar sesión</button>
      </div>
    );
  }
  return children;
}

export default AppAccessGate;
